import React from "react";
import "./StudentGrid.sass";
import SimpleGrid from "../../_containers/grid/SimpleGrid";
import IconItemGrid, {IconItemGridType} from "../../_components/common/grid/IconItemGrid";
import {ReactComponent as Homework} from "../../images/release/homework.svg"
import {ReactComponent as Training} from "../../images/release/training.svg"
import {ReactComponent as Person} from "../../images/release/person.svg"
import {ReactComponent as Balance} from "../../images/release/balance.svg"
import {blue, green, red} from "../../common/colors";
import {useLocation} from "react-router";
import {useSelector} from "react-redux";
import InfoMessage from "../common/grid/InfoMessage";
import {BALANCE_PAGE, HOME, HOMEWORK_STUDENT_PAGE, TRAINERS_PAGE} from "../../common/links";

export default function StudentGrid() {

    const {current} = useSelector(state => state.auth);
    const {data: info} = useSelector(state => state.notification.getInfo);

    const location = useLocation();

    return (
        <div className="StudentGrid-wrapper">
            <SimpleGrid>
                <IconItemGrid Icon={Person}
                              link={HOME}
                              backgroundColor={blue}
                              title="Ученик"
                              selected={location.pathname === HOME}
                              type={IconItemGridType.COMMON}/>
                <IconItemGrid Icon={Homework}
                              message={info && !!info.hwCount ? <InfoMessage type="info"/> : undefined}
                              link={HOMEWORK_STUDENT_PAGE}
                              backgroundColor={blue}
                              title="Домашнее задание"
                              selected={location.pathname === HOMEWORK_STUDENT_PAGE}
                              type={IconItemGridType.COMMON}/>
                <IconItemGrid Icon={Training}
                              link={TRAINERS_PAGE}
                              selected={location.pathname === TRAINERS_PAGE}
                              backgroundColor={blue}
                              title="Тренажёры"
                              type={IconItemGridType.COMMON}/>
                <IconItemGrid Icon={Balance}
                              alt={(parseInt(current.balance) / 100).toFixed(2)}
                              link={BALANCE_PAGE}
                              selected={location.pathname === BALANCE_PAGE}
                              title="Баланс"
                              backgroundColor={current.balance > 0 ? green : red}
                              type={IconItemGridType.COMMON}/>
            </SimpleGrid>
        </div>
    )
}